import { useEffect, useState, useCallback } from 'react'

export function useHeroSlider(total: number, intervalMs: number) {
  const [index, setIndex] = useState(0)

  const next = useCallback(() => setIndex((i) => (i + 1) % total), [total])
  const prev = useCallback(() => setIndex((i) => (i - 1 + total) % total), [total])
  const goTo = useCallback((i: number) => setIndex(i % total), [total])

  useEffect(() => {
    const id = setInterval(next, intervalMs)
    return () => clearInterval(id)
  }, [next, intervalMs])

  return { index, next, prev, goTo }
}
